import script from "./CourtLists.vue?vue&type=script&setup=true&lang=js"
export * from "./CourtLists.vue?vue&type=script&setup=true&lang=js"

import "./CourtLists.vue?vue&type=style&index=0&id=13025cec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13025cec"]])

export default __exports__